<template>
  <div class="SingleOptionSelect">
    <div v-if="prompt" class="prompt">{{ prompt }}</div>
    <div
      class="options"
      :class="[optionIcons ? 'withIcons' : 'withoutIcons', { useLargeIcons }]"
    >
      <OptionTile v-for="option in options"
        :key="option.value"
        radio
        v-bind="{ option, disabled, optionIcons }"
        :fieldName="name"
        :isSelected="value === option.value"
        class="option"
        :class="useLargeIcons && '--large'"
        @change.stop="doEmitSelectionChanged"
        @input.stop
      />
    </div>
    <FieldError v-if="error !== null" v-bind="{ error }" class="error" />
  </div>
</template>

<script>
import FieldError from './FieldError.vue'
import OptionTile from './OptionTile.vue'

export default {
  components: {
    FieldError,
    OptionTile,
  },
  props: {
    name: String,
    prompt: String,
    options: Array,
    value: String,
    error: String,
    disabled: Boolean,
    optionIcons: Object,
  },
  computed: {
    useLargeIcons() {
      return this.optionIcons && this.options.length <= 2
    }
  },
  methods: {
    doEmitSelectionChanged({ target }) {
      this.$emit('selectionChange', target.value)
    },
  },
}
</script>

<style scoped>

.prompt {
  color: var(--text-color-dark);
  font-size: var(--font-size-1);
  font-weight: 500;
}

.options {
  margin-top: var(--spacing-2);
}

.options.withoutIcons {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.options.withIcons {
  display: grid;
  gap: var(--spacing-5);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (--screen-lg) {
  .options.withIcons:not(.useLargeIcons) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
